import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Subscription } from 'rxjs';
import { CustomerService } from 'src/app/pages/customer/services/customer.service';
import { PerformancetabService } from 'src/app/pages/customer/services/performancetab.service';

@Component({
  selector: 'app-customerleftwindow',
  templateUrl: './customerleftwindow.component.html',
  styleUrls: ['./customerleftwindow.component.css'],
})
export class CustomerleftwindowComponent implements OnInit, OnDestroy {
  public assetsReported: any;
  public assetCount: number = 0; // 👈 number type
  public _atmCount: number = 30;
  public isLoading: boolean = true;
  public customer_id: string | null = null;
  public customer_logo: string | null = null;

  private assetCountSub!: Subscription;

  constructor(
    private _customerService$: CustomerService,
    private _performanceTabService$: PerformancetabService
  ) {}

  ngOnInit(): void {
    // Get customer info from localStorage
    this.customer_id = localStorage.getItem('customer_id');
    this.customer_logo = localStorage.getItem('customer_logo');

    // Subscribe to reactive dashboard ATM count
    this.assetCountSub = this._customerService$.dashboardAtmCount$.subscribe(
      (count) => {
        this.assetCount = count; // Automatically updates view
      }
    );

    // Fetch initial ATM count
    this.atmCount();

    // Fetch initial asset count
    this.getAssetCount();
  }

  // Tab change handler
  onChange(event: MatTabChangeEvent) {
    const tab = event.tab.textLabel;

    if (tab === '30 Days') this._atmCount = 30;
    else if (tab === '7 Days') this._atmCount = 7;
    else if (tab === 'Today') this._atmCount = 1;

    this.assetsReported = 0;
    this.atmCount();
  }

  // Fetch ATM counts based on selected tab
  public atmCount(): void {
    this.isLoading = true;
    this._performanceTabService$
      .takeAtmCount({ date_filter: this._atmCount, customer_id: this.customer_id })
      .subscribe({
        next: (response: any) => {
          this.assetsReported = response.data.atm_counts;
        },
        error: (err: any) => {
          console.error(err.error?.message);
        },
        complete: () => {
          this.isLoading = false;
        },
      });
  }

  // Fetch total asset count from Customer Dashboard API
  public getAssetCount(): void {
    this.isLoading = true;
    this._customerService$
      .listAllTilesAPI({
        customer_id: this.customer_id,
        institute_id: localStorage.getItem('institute_id'),
      })
      .subscribe({
        next: (response: any) => {
          if (response.Code === 200) {
            const count = Number(response.data.asset_count);
            // Update reactive BehaviorSubject so view updates
            this._customerService$.setDashboardAtmCount(count);
          }
        },
        error: (err: any) => {
          console.error(err.error?.message);
        },
        complete: () => {
          this.isLoading = false;
        },
      });
  }

  ngOnDestroy(): void {
    // Clean up subscription
    if (this.assetCountSub) {
      this.assetCountSub.unsubscribe();
    }
  }
}
